import { Component, inject, Input } from '@angular/core';
import { ContentBlockType } from '../content-block-type';
import { ContentBlocksService } from '../content-blocks.service';

@Component({
    selector: 'tyt-content-block-preview',
    templateUrl: './content-block-preview.component.html',
    styleUrl: './content-block-preview.component.scss',
    standalone: false
})
export class ContentBlockPreviewComponent {
    blockTypes = inject(ContentBlocksService);

    @Input() block: ContentBlockType;
    previewOf(blockType: ContentBlockType) {
        return this.blockTypes.getPreview(blockType);
    }
}